export const skeleton = () => [
    {
        type: 'circle',
        align: 'right',
        diameter: 3
    },
    {
        type: 'circle',
        diameter: 13,
        align: 'center'
    },
    {
        type: 'text',
        width: 80,
        align: 'center'
    }
];
